import React from "react";
import { Timeline, Collapse, Typography, Tooltip, Progress, Space } from "antd";
import {
  FolderOpenOutlined,
  BookOutlined,
  CheckCircleTwoTone,
  PlayCircleTwoTone,
  ClockCircleTwoTone,
  LockOutlined,
} from "@ant-design/icons";

const { Panel } = Collapse;
const { Text } = Typography;

const statusIcons = {
  Completed: (
    <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 18 }} />
  ),
  Started: (
    <PlayCircleTwoTone twoToneColor="#1677ff" style={{ fontSize: 18 }} />
  ),
  Enrolled: (
    <ClockCircleTwoTone
      twoToneColor="#faad14"
      style={{ fontSize: 18, background: "transparent" }}
    />
  ),
  Locked: <LockOutlined style={{ color: "#aaa", fontSize: 18 }} />,
};

export const LearningPathJourney = () => {
  //   const user = {
  //     id: "U2025",
  //     name: "Joyce Smith",
  //   };

  const pathData = [
    {
      id: 1,
      type: "bundle",
      name: "Frontend Basics",
      description: "Learn the fundamentals of HTML, CSS, and JS.",
      status: "Completed",
      courses: [
        { id: "c1", name: "HTML & CSS", status: "Completed" },
        { id: "c2", name: "JavaScript Essentials", status: "Completed" },
        { id: "c3", name: "Responsive Design", status: "Completed" },
      ],
    },
    {
      id: 2,
      type: "course",
      name: "React.js Fundamentals",
      status: "Started",
    },
    {
      id: 3,
      type: "bundle",
      name: "Advanced React Track",
      description: "Dive deep into state management and performance.",
      status: "Enrolled",
      courses: [
        { id: "c4", name: "React Hooks Deep Dive", status: "Enrolled" },
        { id: "c5", name: "Redux Toolkit", status: "Locked" },
      ],
    },
  ];

  // Helper to calculate bundle progress
  const getBundleProgress = (courses) => {
    const total = courses.length;
    const completed = courses.filter((c) => c.status === "Completed").length;
    return Math.round((completed / total) * 100);
  };

  return (
    <div
      style={{
        maxWidth: 750,
        margin: "0 auto",
        padding: "24px 16px",
        fontFamily: "Roboto, sans-serif",
      }}
    >
      {/* User Info */}
      {/* <div
        style={{
          background: "#f9f9f9",
          borderRadius: 16,
          padding: "20px 24px",
          marginBottom: 24,
          boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
        }}
      >
        <Title level={4} style={{ marginBottom: 4 }}>
          {user.name}
        </Title>
        <Text type="secondary">User ID: {user.id}</Text>
      </div> */}

      {/* Timeline */}
      <Timeline
        mode="left"
        style={{
          "--line-color": "#e0e0e0",
        }}
      >
        {pathData.map((item, index) => {
          const isActive = item.status === "Started";
          const lineColor =
            item.status === "Completed"
              ? "green"
              : item.status === "Started"
              ? "#1677ff"
              : "#ccc";

          return (
            <Timeline.Item
              key={item.id}
              color={lineColor}
              dot={
                item.type === "bundle" ? (
                  <FolderOpenOutlined
                    style={{
                      fontSize: 20,
                      color: isActive ? "#1677ff" : lineColor,
                    }}
                  />
                ) : (
                  <BookOutlined
                    style={{
                      fontSize: 18,
                      color: isActive ? "#1677ff" : lineColor,
                    }}
                  />
                )
              }
            >
              <div
                style={{
                  background: isActive ? "#f0f7ff" : "#fff",
                  border: isActive
                    ? "1px solid #1677ff"
                    : "1px solid rgba(0,0,0,0.1)",
                  borderRadius: 12,
                  padding: "16px 18px",
                  transition: "0.3s",
                  boxShadow: isActive
                    ? "0 3px 10px rgba(22,119,255,0.2)"
                    : "0 2px 6px rgba(0,0,0,0.05)",
                }}
              >
                {/* Header */}
                <Space align="center" size="middle">
                  {statusIcons[item.status]}
                  <Text strong style={{ fontSize: 15 }}>
                    {index + 1}. {item.name}
                  </Text>
                </Space>

                {/* Description */}
                {item.description && (
                  <Text
                    type="secondary"
                    style={{ display: "block", fontSize: 13, marginTop: 4 }}
                  >
                    {item.description}
                  </Text>
                )}

                {item.type === "bundle" && (
                  <Collapse
                    ghost
                    style={{ marginTop: 12, cursor: "pointer" }}
                    expandIconPosition="end"
                    // expandIcon={() => null}
                  >
                    <Panel
                      header={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                        >
                          <Progress
                            percent={getBundleProgress(item.courses)}
                            size="small"
                            style={{ width: 140, marginRight: 10 }}
                          />
                          <Text type="secondary" style={{ fontSize: 13 }}>
                            Complete
                          </Text>
                        </div>
                      }
                      key={item.id}
                    >
                      <Timeline
                        style={{
                          marginLeft: 20,
                          marginTop: 10,
                          marginBottom: 0,
                          padding: 0,
                        }}
                        items={item.courses.map((course) => ({
                          color:
                            course.status === "Completed"
                              ? "green"
                              : course.status === "Started"
                              ? "blue"
                              : "gray",
                          dot: (
                            <Tooltip title={course.status}>
                              {statusIcons[course.status]}
                            </Tooltip>
                          ),
                          children: (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                padding: "4px 0",
                              }}
                            >
                              <Text
                                strong
                                style={{
                                  color: "#555",
                                }}
                              >
                                {course.name}
                              </Text>
                            </div>
                          ),
                        }))}
                      />
                    </Panel>
                  </Collapse>
                )}
              </div>
            </Timeline.Item>
          );
        })}
      </Timeline>
    </div>
  );
};
